<template>
  <div style="margin-top: -24px">
    <v-container fluid>
      <v-card flat class="disable-scrollbars" color="transparent">
        <v-row style="min-height: 50px">
          <v-col class="text-justify"  sm="12" md="6" lg="4" xs="12">
            <v-card elevation="0" class="mt-n3" min-width="350">
              <v-card-text>
                <v-list-item three-line>
                  <v-list-item-content>
                    <div
                      class="overline mb-4 font-weight-bold blue-grey--text"
                      style="font-size: 11px !important;"
                    >
                      Protecção de Dados
                    </div>
                    <v-list-item-subtitle class="punk-border"
                      >A Kyami nunca partilha a sua informação particular com terceiros.</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="punk-border"
                      >As sua palavra-passe é criptografada e posteriormente armazenada.</v-list-item-subtitle
                    >
                  </v-list-item-content>

                  <v-list-item-avatar tile size="120" color="transparent" class="d-none d-sm-flex">
                    <v-progress-circular
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                      color="#1976d2c4"
                    >
                      <span style="font-size: 35px">1</span>
                    </v-progress-circular>
                  </v-list-item-avatar>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col class="text-justify" sm="12" md="6" lg="4" xs="12">
            <v-card elevation="0" class="mt-n3" min-width="350">
              <v-card-text>
                <v-list-item three-line>
                  <v-list-item-content>
                    <div
                      class="overline mb-4 font-weight-bold blue-grey--text"
                      style="font-size: 11px !important;"
                    >
                      Protecção de Dados
                    </div>
                    <v-list-item-subtitle class="punk-border"
                      >A Kyami Pay nunca pede pede o seu PIN de transações.</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="punk-border"
                      >A Kyami Pay nunca pede a sua palavra-passe.</v-list-item-subtitle
                    >
                  </v-list-item-content>

                  <v-list-item-avatar tile size="120" color="transparent" class="d-none d-sm-flex">
                    <v-progress-circular
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                      color="#1976d2c4"
                    >
                      <span style="font-size: 35px">2</span>
                    </v-progress-circular>
                  </v-list-item-avatar>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col class="text-justify" sm="12" md="6" lg="4" xs="12">
            <v-card elevation="0" class="mt-n3" min-width="350">
              <v-card-text>
                <v-list-item three-line>
                  <v-list-item-content>
                    <div
                      class="overline mb-4 font-weight-bold blue-grey--text"
                      style="font-size: 11px !important;"
                    >
                      Protecção de Dados
                    </div>
                    <v-list-item-subtitle class="punk-border"
                      >Os nossos canais oficiais estão apresentados no nosso website.</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="punk-border"
                      >Os nossos domínios oficiais são: kyamipay.ao e kpay.ao</v-list-item-subtitle
                    >
                  </v-list-item-content>

                  <v-list-item-avatar tile size="120" color="transparent" class="d-none d-sm-flex">
                    <v-progress-circular
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                      color="#1976d2c4"
                    >
                      <span style="font-size: 35px">3</span>
                    </v-progress-circular>
                  </v-list-item-avatar>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Compliance"
};
</script>

<style scoped>
.punk-border {
  width: 10px;
  border-left: 10px solid rgba(25, 118, 210, 0.77);
  padding: 5px;
  margin-right: 5px;
}
</style>
